import React, { memo } from "react";
import Modal from "../../shared/Modal";
import { prefix } from "../../../../i18n";
import OrderItemsList from "../../shared/OrderItemsList";
import CustomButton from "../../shared/CustomButton";

const tCartCheckout = prefix("cart-checkout");

const ModalMsgSpan = memo(({ msg }) => (
  <div className="gl2026-modal__alert gl2026-modal__alert--success">
    <i className="fa fa-check-circle" />
    <span>{msg}</span>
  </div>
));

const AlertMsgSpan = memo(({ alertMsg }) => (
  <div className="gl2026-modal__alert">
    <i className="fa fa-times-circle" />
    <span>{alertMsg}</span>
  </div>
));

const CartCheckoutModal = memo(
  ({ selected, content, onNoAccept, onAccept }) => {
    const { title, alertMsg, msg, items, shouldUseCoPayment } = content;

    const handleNoAcceptAction = (e) => {
      e.preventDefault();
      onNoAccept();
    };

    const handleAcceptAction = (e) => {
      e.preventDefault();
      onAccept();
    };

    return (
      <Modal show={selected} lessPadding className="cart-checkout-modal">
        <div className="gl2026-modal__header noborder">
          <h5 className="gl2026-modal__title">{title || tCartCheckout("checkout-default-alert-title")}</h5>
        </div>
        <div className="gl2026-modal__body">
          {alertMsg && <AlertMsgSpan alertMsg={alertMsg} />}
          {msg}
          {shouldUseCoPayment && items && <OrderItemsList items={items} />}
        </div>
        <div className="gl2026-modal__footer">
          <CustomButton secondary type="button" onClick={handleNoAcceptAction}>
            {tCartCheckout("checkout-back")}
          </CustomButton>
          <CustomButton type="button" onClick={handleAcceptAction}>
            {tCartCheckout("checkout-confirm")}
          </CustomButton>
        </div>
      </Modal>
    );
  },
);

export default CartCheckoutModal;
